import { createContext } from 'react';
import type { Theme } from './theme';
import { lightTheme } from './theme';

export const ThemeContext = createContext<Theme>(lightTheme);
